module.exports = __webpack_public_path__ + "img/feedback4.d783c07a.webp";